<template>
  <router-view />
</template>

<script>
export default {
  name: 'PortalLayout',
}
</script>

<style scoped></style>
